<script setup lang="ts">
import { useCookieConsent } from "@/composables/cookies/useCookieConsent";
import { useRouter, useRoute } from "vue-router";
import { computed } from "vue";
import { useUiStore } from "@/stores/ui";

const { setConsent } = useCookieConsent();
const router = useRouter();
const route = useRoute();
const uiStore = useUiStore();


const isVisibleViaStore = computed(() => uiStore.showCookieAccessModal);
const isVisibleViaUrl = computed(() => route.query.showCookieModal === 'true');
const isModalVisible = computed(() => isVisibleViaStore.value || isVisibleViaUrl.value);

const acceptAllCookies = async (): Promise<void> => {
  await setConsent('all');
  const savedRoute = localStorage.getItem('lastAttemptedRoute');

  if (savedRoute) {
    localStorage.removeItem('lastAttemptedRoute');
    router.push(savedRoute);
  } else {
    uiStore.showCookieAccessModal = false;
    window.location.reload();
  }
};

const goBack = () => {
  uiStore.showCookieAccessModal = false;
  router.push('/');
};
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isModalVisible" 
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-4"
      @click.self="() => {}"
    >
      <div 
        class="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
      >
        <div class="mb-6">
          <h2 class="flex justify-center text-xl font-bold text-gray-900 dark:text-white mb-2">
            Acesso Restrito
          </h2>
          <p class="text-gray-700 dark:text-gray-300 p-4">
            Para acessar esta página, você precisa aceitar todos os cookies. 
            Isso nos permite fornecer funcionalidades essenciais e melhorar sua experiência.
          </p>
        </div>
        
        <div class="flex justify-center space-x-3">
          <button
            @click="goBack"
            class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
          >
            Voltar
          </button>
          <button
            @click="acceptAllCookies"
            class="px-4 py-2 bg-success hover:bg-success/90 text-white rounded transition"
          >
            Aceitar cookies
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>